<template>
  <div>
    <ClientBookingCreateNew v-if="$getConstRole('ROLE_CLIENT') == role"></ClientBookingCreateNew>
    <AgentBookingCreateNew v-if="$getConstRole('ROLE_AGENT') == role"></AgentBookingCreateNew>
    <AdminBookingCreateNew v-if="$getConstRole('ROLE_ADMIN') == role"></AdminBookingCreateNew>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ClientBookingCreateNew from '@/views/client/booking/Add.vue'
import AgentBookingCreateNew from '@/views/agent/booking/Add.vue'
import AdminBookingCreateNew from '@/views/admin/booking/Add.vue'

export default {
  name: 'BookingsCreateNew',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    AgentBookingCreateNew,
    ClientBookingCreateNew,
    AdminBookingCreateNew
  },
};
</script>
